import { Chips } from "primereact/chips";
import { Delivery, RowType } from "../types";
import CustomChip from "./CustomChip";

type Props = {
  value: string[];
  rowData: Partial<RowType>;
  field: string; // "trucks" or "trailers"
  onChange: (updated: string[]) => void;
};

export default function CustomChipsDisplay({
  value,
  rowData,
  field,
  onChange,
}: Props) {
  const currentChips: string[] = Array.isArray(value) ? value : [];
  const deliveries: Delivery[] =
    (rowData as { scheduledDeliveries?: Delivery[] })["scheduledDeliveries"] ??
    [];

  // vehicles that are scheduled (not cancelled or confirmed)
  const usedInFuture = new Set(
    deliveries
      .filter((delivery) => {
        const isActive =
          delivery.status !== "CANCELLED" && delivery.status !== "CONFIRMED";

        return (
          isActive &&
          ((field === "trucks" && delivery.truck) ||
            (field === "trailers" && delivery.trailer))
        );
      })
      .map((delivery) =>
        field === "trucks" ? delivery.truck : delivery.trailer,
      )
      .filter(Boolean),
  );

  const handleRemove = (chipToRemove: string) => {
    const updated = currentChips.filter((chip) => chip !== chipToRemove);
    onChange(updated);
  };

  return (
    <Chips
      value={currentChips}
      className="custom-chips-container"
      onChange={(e) => {
        onChange(e.value ?? []);
      }}
      allowDuplicate={false}
      removable={false}
      itemTemplate={(chip: string) => (
        <CustomChip
          chip={chip}
          isLocked={usedInFuture.has(chip)}
          onRemove={handleRemove}
        />
      )}
    />
  );
}
